import { connect } from 'react-redux';
import { registerAgency } from '../modules/register';

import Register from '../components/Register';


const mapDispatchToProps = {
  registerAgency,
};

const mapStateToProps = (state, ownProps) => ({
  status: state.register.status,
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// src/routes/agency/containers/RegisterContainer.js